// extracted by mini-css-extract-plugin
module.exports = {"stripMessage":"InfoTip_stripMessage___3Qs0","header":"InfoTip_header__T-OXj","content":"InfoTip_content__2o8gw","noHorizontalOutset":"InfoTip_noHorizontalOutset__2pONd"};